import type { FunctionComponent } from 'react';

import type { IPaymentProcessResponse, MethodType } from '@endeavour/payment-integration';
import { RedirectType } from '@endeavour/payment-integration';

import { ContextNavigate } from '../../../shared/components/context-navigate/context-navigate';
import { createStyleHelper, createClassName } from '../../../shared/utils/class-names';
import { Iframe } from '../iframe/iframe';
import { Redirect } from '../redirect/redirect';
import { WindowPopup } from '../window-popup/window-popup';

import styles from './payment-redirect.module.scss';

const style = createStyleHelper(styles, 'payment-redirect');

export interface IPaymentRedirectProps {
    className?: string;
    type: MethodType;
    responseModel: IPaymentProcessResponse;
}

export const PaymentRedirect: FunctionComponent<IPaymentRedirectProps> = ({
    className,
    type,
    responseModel,
}) => {
    if (responseModel.redirectOutput?.container === RedirectType.IFRAME) {
        return (
            <div className={createClassName([className, style()])}>
                <Iframe responseModel={responseModel} />
            </div>
        );
    }

    if (responseModel.redirectOutput?.container === RedirectType.REDIRECT) {
        return (
            <div className={createClassName([className, style()])}>
                <Redirect responseModel={responseModel} />
            </div>
        );
    }

    if (responseModel.redirectOutput?.container === RedirectType.WINDOW) {
        return (
            <div className={createClassName([className, style()])}>
                <WindowPopup responseModel={responseModel} />
            </div>
        );
    }

    return (
        <ContextNavigate
            to={`/cashier/${type.toLowerCase()}/complete/${responseModel.transactionId}`}
        />
    );
};
